import React, { Component, useLayoutEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Router, Switch, Route } from 'react-router-dom'
import history from './utils/history'

import './styles/index.scss'
import { appStart } from './redux/actions/app'
import MainRouter from './MainRouter'
import Login from './pages/Login'
import Signup from './pages/Signup'
import VerifyPage from './pages/Verify'
import VerifyDomainPage from './pages/VerifyDomain'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import ScrollToTop from './components/CommonComponents/ScrollToTop'
class App extends Component {
  render() {
    return (
      <Router
        basename={`${process.env.PUBLIC_URL}`}
        history={history}
      >
        <ScrollToTop>
          <Switch>
            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              component={Login}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/signup`}
              component={Signup}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/verify/:email/:hash`}
              component={VerifyPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/acceptInvitation/:emailToVerify/:hash`}
              component={VerifyDomainPage}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/forgotpassword`}
              component={ForgotPassword}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/resetpassword/:email/:hash`}
              component={ResetPassword}
            />
            <Route path="/" component={MainRouter} />
          </Switch>
        </ScrollToTop>
      </Router>
    )
  }
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    appStart,
    // createDevice: async () => await dispatch(createTwilioDevice(dispatch)),
    // createSocket: (socket) => dispatch({
    //   type: CREATE_SOCKET_CONNECTION,
    //   data: socket
    // })
  }, dispatch)
}
// export default App
export default connect(mapStateToProps, mapDispatchToProps)(App)